// extracted by mini-css-extract-plugin
export default {"container":"Account_container__UXebi","label":"Account_label__MkN5h","arrowButton":"Account_arrowButton__7pov9"};